import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import * as yup from 'yup';

import { useMutationAuthRecoverPassword } from 'gql/mutations/auth';
import extract from 'helpers/extract';
import { trackEvent, reportError } from 'lib/tracking';

import RecoverPassword from './RecoverPassword';

const RecoverPasswordContainer = () => {
  const { t } = useTranslation();
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        email: yup
          .string()
          .trim()
          .lowercase()
          .required(t('Auth/RecoverPassword/email-error-required'))
          .email(t('Auth/RecoverPassword/email-error-required'))
          .max(256, t('Auth/RecoverPassword/email-error-required')),
      }),
    [t],
  );
  const mutationAuthRecoverPassword = useMutationAuthRecoverPassword();
  const [isDone, setDone] = useState(false);
  const handleRecoverPassword = useCallback(
    async (values, form) => {
      try {
        form.setStatus(null);
        const variables = extract(values, validationSchema);
        await mutationAuthRecoverPassword(variables);
        setDone(true);
        trackEvent('auth', 'recover-password');
      } catch (err) {
        form.setStatus(err.message);
        reportError('auth', 'recover-password', err);
      }
    },
    [mutationAuthRecoverPassword, validationSchema],
  );
  const { state } = useLocation();
  return (
    <RecoverPassword
      defaultEmail={state?.email || ''}
      handleRecoverPassword={handleRecoverPassword}
      isDone={isDone}
      t={t}
      validationSchema={validationSchema}
    />
  );
};

export default RecoverPasswordContainer;
